"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirect = exports.getSeo = exports.getAuthHeadersToken = exports.checkCPAndSetZones = void 0;
const effects_1 = require("redux-saga/effects");
const next_app_controller_reducers_sagas_main_reducer_r_1 = require("@gerenciatd/next.app-controller.reducers-sagas.main-reducer-r");
const next_utils_request_1 = __importDefault(require("@gerenciatd/next.utils.request"));
const filePath = 'sagas/main.js';
const contextStore = (state) => state.main.context;
function* checkCPAndSetZones({ data }) {
    try {
        const { cp, needBussinesZone } = data;
        let module = yield (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require('@gerenciatd/next13.adabyron.geo.get-cp-zone'))));
        module = module.default;
        const lastCP = yield (0, effects_1.select)(state => state.main.cp);
        const context = yield (0, effects_1.select)(state => state.main.context);
        // need get again bussinessZones, cuando montamos el modal con datos ya persistidos y no tenmoes la lista de municipios
        if (needBussinesZone) {
            yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_r_1.actions.setCheckedCPByApi(false));
            let response = yield (0, effects_1.call)(module, { cp, context });
            const { businessZones } = response;
            const lastZone = yield (0, effects_1.select)(state => state.main.zone);
            const lastMunicipio = yield (0, effects_1.select)(state => state.main.municipio);
            response = {
                cp: lastCP,
                zone: lastZone,
                municipio: lastMunicipio,
                businessZones,
            };
            yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_r_1.actions.setCheckedCPByApi(true));
            yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_r_1.actions.setCpParams(response));
        }
        // regular behaviour
        if (!needBussinesZone && lastCP !== cp) {
            yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_r_1.actions.setCheckedCPByApi(false));
            let response = yield (0, effects_1.call)(module, { cp, context });
            let zone = (response && response.zone) || 'ZL';
            let municipio = null;
            // getting first result and using its zone
            if (response && response.businessZones && Array.isArray(response.businessZones) && response.businessZones.length > 0) {
                const { businessZoneName } = response.businessZones[0];
                zone = businessZoneName;
                municipio = response.businessZones[0];
            }
            response = Object.assign(Object.assign({}, response), { cp: response.postalCode, zone,
                municipio });
            delete response.postalCode;
            yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_r_1.actions.setCpParams(response));
            yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_r_1.actions.setCheckedCPByApi(true));
        }
    }
    catch (err) {
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_r_1.actions.setCheckedCPByApi(false));
    }
}
exports.checkCPAndSetZones = checkCPAndSetZones;
const getAuthHeadersToken = (build = true, system = 'cms') => {
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    let authorizationHeader = {};
    if (system === 'cms') {
        if (currentEnv === 'qa' && build) {
            authorizationHeader = JSON.parse(`${process.env.NEXT_PUBLIC_CMS_TOKEN}`);
        }
    }
    if (system === 'customizer') {
        if (currentEnv === 'qa' && build) {
            authorizationHeader = JSON.parse(`${process.env.NEXT_PUBLIC_CUSTOMIZER_TOKEN}`);
        }
    }
    return authorizationHeader;
};
exports.getAuthHeadersToken = getAuthHeadersToken;
const fetchSEO = (seoReq) => __awaiter(void 0, void 0, void 0, function* () {
    let url = 'https://customizer.col.movistar.es/api/seo/get';
    let headers = {
        'Content-Type': 'application/json',
        Origin: 'https://www.movistar.es',
    };
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    if (currentEnv === 'qa') {
        url = 'https://qa.customizer.col.movistar.es/api/seo/get';
        const authHeaders = (0, exports.getAuthHeadersToken)(true, 'customizer');
        headers.Origin = 'https://qa.cms.col.movistar.es';
        headers = Object.assign(Object.assign({}, headers), authHeaders);
    }
    const request = new next_utils_request_1.default({
        method: 'POST',
        endpoint: url,
        data: seoReq,
        headers,
    });
    const resp = request.makeRequest();
    return resp;
});
function* getSeo({ seoReqData }) {
    const context = yield (0, effects_1.select)(contextStore);
    try {
        const res = yield (0, effects_1.call)(fetchSEO, seoReqData, context);
        const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
        if (res && !res.errno) {
            yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_r_1.actions.setCurrentSeo(res));
        }
        if ((!res || res.errno) && currentEnv !== 'dev') {
            throw new Error('No tenemos datos de seo');
        }
    }
    catch (error) {
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_r_1.actions.throwSonda({
            processName: 'getSeo',
            filePath,
            error,
            kind: next_app_controller_reducers_sagas_main_reducer_r_1.SONDA_KIND.ERROR,
        }));
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_r_1.actions.setCurrentSeo(null));
    }
}
exports.getSeo = getSeo;
function* redirect({ data }) {
    const { url, eventInfo } = data;
    try {
        if (url && eventInfo) {
            yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_r_1.actions.sendCmsEvent(eventInfo, () => {
                document.location.href = url;
            }));
        }
        if (url && !eventInfo) {
            document.location.href = url;
        }
    }
    catch (error) {
        yield (0, effects_1.put)(next_app_controller_reducers_sagas_main_reducer_r_1.actions.throwSonda({
            processName: 'redirect',
            filePath,
            error,
            kind: next_app_controller_reducers_sagas_main_reducer_r_1.SONDA_KIND.ERROR,
        }));
    }
}
exports.redirect = redirect;
//# sourceMappingURL=index.js.map